import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { AcceptConditionsClientResponse } from '../@types/acceptConditions'

type Store = {
  acceptConditions: AcceptConditionsClientResponse | null
  setAcceptConditions: (value: AcceptConditionsClientResponse) => void
}

export const useAcceptConditionsStore = create<Store>()(
  devtools(
    (set) => ({
      acceptConditions: null,
      setAcceptConditions: (acceptConditions) => set({ acceptConditions }),
    }),
    { name: 'AcceptConditionsStore' },
  ),
)
